// extracted by mini-css-extract-plugin
export default {"backContainer":"BackChevron_backContainer__IcJa5","backIcon":"BackChevron_backIcon__xgFOR"};